import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageTitle, statusColor } from "@/components/DashUI";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

const LEAD_STATUSES = ["NEW_LEAD", "CONTACT_ATTEMPTED", "CONTACTED", "QUALIFIED", "FAMILY_CONSULTATION",
  "NEEDS_IDENTIFIED", "PROVIDER_MATCHING", "INTRODUCTION", "TOUR_MEETING", "APPLICATION", "ACCEPTED",
  "SERVICE_START_PENDING", "SERVICE_STARTED", "PLACED", "PAYMENT_CONFIRMED", "COMMISSION_REVIEW",
  "COMMISSION_APPROVED", "COMMISSION_PAID", "CLOSED", "NOT_QUALIFIED"];

export default function Pipeline() {
  const [leads, setLeads] = useState([]);
  const load = () => api.get("/agent/leads").then((r) => setLeads(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const advance = async (lead, status) => {
    try { await api.patch(`/agent/leads/${lead.id}/status`, { status, note: `Moved to ${status}` }); toast.success("Status updated"); load(); }
    catch { toast.error("Update failed"); }
  };

  const active = leads.filter((l) => !["CLOSED", "NOT_QUALIFIED"].includes(l.status));

  return (
    <div>
      <PageTitle title="My Pipeline" subtitle="Advance leads through the placement pipeline" />
      <div className="space-y-3">
        {active.map((l) => (
          <Card key={l.id} className="flex flex-col gap-3 p-5 sm:flex-row sm:items-center sm:justify-between" data-testid={`pipeline-row-${l.id}`}>
            <div>
              <div className="flex items-center gap-2">
                <span className="font-heading font-semibold text-navy">{l.lead_nickname}</span>
                <span className="font-mono text-xs text-slate-400">{l.lead_id}</span>
              </div>
              <p className="mt-1 text-sm text-slate-500">{l.service_category} · {l.geographic_area}, {l.state}</p>
            </div>
            <div className="flex items-center gap-3">
              <Badge className={`${statusColor(l.status)} hover:${statusColor(l.status)}`}>{(l.status || "").replace(/_/g, " ")}</Badge>
              <Select value={l.status} onValueChange={(v) => advance(l, v)}>
                <SelectTrigger data-testid={`pipeline-status-${l.id}`} className="w-52"><SelectValue /></SelectTrigger>
                <SelectContent>{LEAD_STATUSES.map((s) => <SelectItem key={s} value={s}>{s.replace(/_/g, " ")}</SelectItem>)}</SelectContent>
              </Select>
            </div>
          </Card>
        ))}
        {active.length === 0 && <Card className="p-10 text-center text-slate-400">No active leads in your pipeline.</Card>}
      </div>
    </div>
  );
}
